module.exports = __webpack_public_path__ + "static/media/README.1159117c.md";